import "abortcontroller-polyfill";
import { wvusLogger } from "../../lib";
interface RequestOpts extends RequestInit {
  timeout?: number;
}

export default function fetchRequest(
  requestUrl: string,
  requestOpts: RequestOpts
): Promise<Response> {
  const controller = new AbortController();
  const signal = controller.signal;
  const { timeout = 0, ...opts } = { ...requestOpts, ...{ signal } };
  // const request = new window.Request(requestUrl, opts);
  const fetchPromise = fetch(requestUrl, opts);
  const completedRequest = new Promise<Response>((resolve, reject) => {
    const timeoutId =
      (timeout &&
        setTimeout(() => {
          // Reject Promise With Error Message
          reject(new Error(`Request timed out after ${timeout} milliseconds.`));
          controller.abort();
        }, timeout)) ||
      null;

    fetchPromise
      .then((promiseVal) => {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        resolve(promiseVal);
      })
      .catch((result) => {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        wvusLogger.log(
          new Error(`Error result during fetchRequest to ${requestUrl}:  ${result}`),
          wvusLogger.getLogLevelNames().ERROR
        );
        reject(result);
      });
  });

  return completedRequest;
}
